// Çeviri alanlarının form adı: `name` + dil kodu büyük harf → `nameEN`, `nameFR`.
//
// Diller artık BURADA DEĞİL. Sabit üçlü (`CONTENT_LANGS`) kaldırıldı: aynı liste menüde, API'nin
// çeviri ucunda ve şemada da duruyordu, yani bir dil eklemek beş yeri değiştirmekti. Kaynak
// Language tablosu; panel onu hooks/useMenuLanguages ile okuyor ve bu fonksiyonlara veriyor.
const fieldName = (field, code) => `${field}${code.toUpperCase()}`;

// Flat form alanları (nameEN, nameFR, ...) → translations objesi. Boş alanlar atlanır; hiçbir dilde
// içerik yoksa null döner (kolonu boş bırak).
export const buildTranslations = (values, fields, languages) => {
  const translations = {};

  for (const { code } of languages) {
    const entry = {};

    for (const field of fields) {
      const value = (values[fieldName(field, code)] ?? "").trim();

      if (value) {
        entry[field] = value;
      }
    }

    if (Object.keys(entry).length) {
      translations[code] = entry;
    }
  }

  return Object.keys(translations).length ? translations : null;
};

// translations objesi → flat form alanları (edit'te formu doldurmak için).
//
// DİKKAT: bu ikili yalnızca verilen dilleri geziyor, yani kiracının KAPATTIĞI bir dilde eskiden
// girilmiş çeviri forma gelmiyor ve kaydetmede düşüyor. Bilinçli: kapalı dil menüde zaten
// görünmüyor, satırda taşınması "açınca geri gelir" beklentisi yaratırdı ve o beklenti ilk
// kaydetmede boşa çıkardı.
export const flattenTranslations = (translations, fields, languages) => {
  const flat = {};

  for (const { code } of languages) {
    for (const field of fields) {
      flat[fieldName(field, code)] = translations?.[code]?.[field] ?? "";
    }
  }

  return flat;
};
